import { render } from "./DateCore.vue?vue&type=template&id=55e61577&ts=true"
import script from "./DateCore.vue?vue&type=script&lang=ts"
export * from "./DateCore.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__